export default {
  'user.profile.company': 'Company',
  'user.profile.position': 'Position',
  'user.profile.changePassword': 'Change Password',
  'user.profile.twoFactor': 'Enable Two-Factor',
  'user.profile.modifyView': 'Modify View',
  'user.profile.currentPassword': 'Current Password',
  'user.profile.password': 'New Password',
  'user.profile.confirmPassword': 'Confirm Password',
  'user.profile.labelTwoFactor': 'Is Two-Factor Authentication Enabled?',
  'user.profile.': ' ',

  'user.menu.logout': 'Logout',
  'user.menu.options': 'Options',
  'user.menu.profile': 'Profile',
  'user.menu.resetPassword': 'Reset Password',
  'user.menu.locales': 'Languages',
  'user.menu.environments': 'Environments',
  'user.menu.companies': 'Companies',

  'user.forgot.title': 'Forgot Password',
  'user.forgot.sent': 'Done!',
  'user.forgot.description':
    'Enter your email and we will send you a message to create your new password',
  'user.forgot.sent.description':
    'We have sent you a link to your email so you can create a new password.',

  'user.login.forgotPassword': 'Forgot Password',
  'user.login.reset.hint':
    'Must be at least 8 characters long, include uppercase and lowercase letters, a number, and a special character "!#*$@%&?".',
  'user.login.reset.sent': 'Your new password has been successfully created.',
  'user.login.reset.title': 'Enter your new password',
  'user.login.reset.link.error.title': 'Error',
  'user.login.reset.link.error.description': 'The link for password reset is invalid.',

  'user.twoFactor.providers': 'Providers',
  'user.twoFactor.provider.email': 'Email Code',
  'user.twoFactor.title': 'Send Verification Code',
  'user.twoFactor.description': 'Select Two-Factor Authentication provider',
  'user.twoFactor.code.title': 'Enter Verification Code',
  'user.twoFactor.alert.title': 'Done!',
  'user.twoFactor.alert.description': 'We have sent you an email with the security code.',
  'user.twoFactor.error.send': 'Error sending verification code. Please try again.',
  'user.twoFactor.error.validate': 'Incorrect security code. Please try again.',

  'user.login.subtitle': 'Use another service to login',
  'user.login.confirm.link.error.description': 'The link to confirm your account is invalid.',
  'user.login.banner.title': 'The future is now',
  'user.login.banner.description': 'Manage, configure, and optimize your processes with our tool.',
};
